export function formatPlanTitle(planTitle) {
  return planTitle && planTitle.replace(/[^a-zA-Z ]/g, " ")
}
